<template>
<div>
  <tag-text-field label="Roles jobseeker will consider" placeholder="Roles"
  v-model="roles" />
  <field label="Job type">
  <div class="control">
    <tag-select placeholder="Job type" :options="contractTypeList" v-model="contractTypes" />
  </div>
  </field>
  <tag-text-field label="Skills" v-model="skills" />
  <div class="field is-horizontal">
    <div class="field-body">
      <CurrencyField label="Salary expectations (min)" v-model="salary" placeholder="Min salary"></CurrencyField>
      <text-field label="Notice period (days)"
        placeholder="Notice period in days" v-model="noticePeriod" />
      </div>
    </div>
    <divider />
    <heading>Resume</heading>
    <div class="resume-field">
      <span>Must have resume attached</span>
      <toggle v-model="resumeRequired" />
    </div>
</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import TagTextField from '@/components/general/tag-text-field'
import Field from '@/components/general/field'
import TagSelect from '@/components/general/tag-select'
import TextField from '@/components/general/text-field'
import Divider from '@/components/general/divider'
import Heading from '@/components/general/heading'
import Toggle from '@/components/toggle'
import CurrencyField from '@/components/general/currency-text-field'

export default {
  components: {
    TagTextField, Field, TagSelect, TextField, Divider, Heading, Toggle, CurrencyField
  },
  data () {
    return {
      contractTypeList: [
        'Permanent',
        'Contract',
        'Freelance'
      ]
    }
  },
  computed: {
    ...mapState('jobseekers/filter', {
      filterRoles: 'roles',
      filterContractTypes: 'contractTypes',
      filterSkills: 'skills',
      filterSalary: 'salary',
      filterNotice: 'noticePeriod',
      filterResume: 'resumeRequired'
    }),
    roles: {
      get () { return this.filterRoles },
      set (value) { this.setRoles(value) }
    },
    contractTypes: {
      get () { return this.filterContractTypes },
      set (value) { this.setContractTypes(value) }
    },
    skills: {
      get () { return this.filterSkills },
      set (value) { this.setSkills(value) }
    },
    salary: {
      get () { return this.filterSalary },
      set (value) { this.setSalary(value) }
    },
    noticePeriod: {
      get () { return this.filterNotice },
      set (value) { this.setNoticePeriod(value) }
    },
    resumeRequired: {
      get () { return this.filterResume },
      set (value) { this.setResumeRequired(value) }
    }
  },
  methods: {
    ...mapMutations('jobseekers/filter', [
      'setRoles',
      'setContractTypes',
      'setSkills',
      'setSalary',
      'setNoticePeriod',
      'setResumeRequired'
    ])
  }
}
</script>

<style lang="scss" scoped>
.button.is-static {
  font-weight: normal;
}
.field.is-horizontal > .field-body > .field {
  margin-bottom: 0rem;
}
h6.heading {
  margin-bottom: 0.5rem;
}
.resume-field {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/jobseekers/jobseeker-filter-form.vue